'use strict';

export default (API) => ({
    setOptions: {
        product: (product) => {
            API.http.defaults.headers.PRODUCT = product;
        },

        role: (role) => {
            API.http.defaults.headers['X-TRIMOZ-ROLE'] = role;
        },
    },
});
